import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocalStorageKeys } from 'src/app/enum/local-storage-keys.enum';
import { LocalStorageService } from 'src/app/services/local-storage/local-storage.service';

interface LanguageItem {
  name: string;
  icon: string;
  id: string;
}

@Component({
  selector: 'app-modal-language-change',
  templateUrl: './modal-language-change.component.html',
  styleUrls: ['./modal-language-change.component.css'],
})
export class ModalLanguageChangeComponent {
  LanguageList: LanguageItem[] = [
    {
      name: this.translateService.instant('USER_NAVBAR.8'),
      icon: '/assets/images/flags/spain.webp',
      id: 'es',
    },
    {
      name: this.translateService.instant('USER_NAVBAR.9'),
      icon: '/assets/images/flags/united_kingdom.webp',
      id: 'en',
    },
    {
      name: this.translateService.instant('USER_NAVBAR.10'),
      icon: '/assets/images/flags/france.webp',
      id: 'fr',
    },
  ];

  FormLanguage: FormGroup = new FormGroup({
    LanguageCode: new FormControl('', Validators.required),
  });

  constructor(
    private bsModalRef: BsModalRef,
    private translateService: TranslateService,
    private readonly localStorageService: LocalStorageService
  ) {
    this.FormLanguage.patchValue({
      LanguageCode: this.translateService.currentLang,
    });
  }

  get SelectedLanguage() {
    const code = this.FormLanguage.get('LanguageCode')?.value;
    return this.LanguageList.find((lang) => lang.id === code);
  }

  changeLanguage(event: LanguageItem) {
    this.FormLanguage.patchValue({
      LanguageCode: event.id,
    });
  }

  close() {
    this.bsModalRef.hide();
  }

  save() {
    if (this.FormLanguage.valid) {
      this.localStorageService.set(
        LocalStorageKeys.LANGUAGE,
        this.FormLanguage.value.LanguageCode
      );
      this.translateService.use(this.FormLanguage.value.LanguageCode);
      this.close();
    }
  }
}
